import script from "./UserCreateStoreAccess.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCreateStoreAccess.vue?vue&type=script&setup=true&lang=js"

import "./UserCreateStoreAccess.vue?vue&type=style&index=0&id=a8e87532&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8e87532"]])

export default __exports__